
export enum MatchedPartyTypeCd {
	BILL_TO_INB = 'BillToInb',
	BILL_TO_OTB = 'BillToOtb',
	CONS = 'Cons',
	CONTACT_ADDRESS = 'Contact Address',
	REQUESTOR_ADDRESS = 'RequestorAddress',
	SHPR = 'Shpr'}

